import type { Handleiding } from './soort';

export const uk: Handleiding = {
  code: 'uk',
  titel: 'Посібник',
  inleiding:
    'Ask Gio Tolk перекладає розмову між двома людьми, які не говорять однією мовою. Нижче описано, що робить кожна кнопка.',
  knop: 'Відкрити посібник',
  sluiten: 'Закрити',
  groepGebruik: 'Брати участь у розмові',
  groepBeheer: 'Налаштування та керування',
  delen: [
    {
      titel: 'Говорити',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Говори',
          uitleg:
            'Торкнись один раз, щоб почати. Запис зупиняється сам, щойно ти помовчиш трохи більше за секунду, або якщо торкнешся ще раз. Через хвилину він зупиняється в будь-якому разі.',
        },
        {
          kop: 'Один звук за раз',
          uitleg:
            'Поки застосунок говорить, записувати не можна. А поки записуєш ти, переклад, що надійшов, чекає, доки ти закінчиш. Інакше мікрофон запише застосунок і вирішить, що це сказав ти.',
        },
        {
          kop: 'Напиши повідомлення тут',
          uitleg:
            'Працює поряд із мовленням і проходить через той самий переклад. Enter надсилає, shift з enter робить новий рядок.',
        },
        {
          kop: 'Час на виправлення',
          uitleg:
            'Тут ти задаєш, скільки секунд маєш, щоб перечитати записану фразу перед відправкою. На нулі вона йде одразу.',
        },
        {
          kop: 'Завжди перевіряти й надсилати самому',
          uitleg:
            'Жодного годинника. Кожна фраза чекає, доки ти натиснеш надіслати. Для того, хто хоче перевіряти кожну фразу.',
        },
        {
          kop: 'Одразу програвати переклад',
          uitleg: 'Увімкнено. Вимкни, якщо волієш спершу прочитати й сам вирішувати, коли слухати.',
        },
      ],
    },
    {
      titel: 'Читати повідомлення',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Те, що великим',
          uitleg:
            'Те, що ТВОЄЮ мовою, показано великим. У твоїй власній фразі це твій вихідний текст, щоб ти міг перевірити, чи правильно застосунок тебе розчув. У фразі співрозмовника це переклад.',
        },
        {
          kop: 'Розгорнути оригінал або переклад',
          uitleg: 'Інша мова розташована нижче, згорнута. Торкнись рядка, щоб її відкрити.',
        },
        {
          kop: 'Трикутничок',
          uitleg: 'Програє переклад ще раз.',
        },
        {
          kop: 'Голова, що говорить',
          uitleg:
            'Програє власний запис співрозмовника. З’являється лише в ПРОМОВЛЕНОМУ повідомленні і лише якщо ввімкнено «надсилати й власний голос». Набране повідомлення запису не має.',
        },
      ],
    },
    {
      titel: 'Кнопки вгорі екрана',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Мінус і плюс',
          uitleg: 'Робить текст меншим або більшим. У п’ять кроків, і налаштування зберігається.',
        },
        {
          kop: 'Мікрофон',
          uitleg: 'Ховає кнопку мовлення, якщо ти все одно лише пишеш. Так заощаджується місце.',
        },
        {
          kop: 'Клавіатура',
          uitleg:
            'Ховає поле введення. Одне з двох завжди лишається ввімкненим, інакше ти вже нічого не зможеш сказати.',
        },
      ],
    },
    {
      titel: 'Вхід',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Якою мовою ти говориш',
          uitleg:
            'Цей вибір задає також мову кнопок і повідомлень. Тож ви обоє бачите різні екрани, і так і задумано.',
        },
        {
          kop: 'Твій голос у перекладі',
          uitleg:
            'Вибери, звучиш ти як чоловік чи як жінка. Це стосується ТЕБЕ, а не кімнати: кожен учасник вибирає окремо.',
        },
        {
          kop: 'Дозвіл на мікрофон',
          uitleg:
            'Браузер запитує про це на вході. Якщо відмовиш, писати все одно можна. Дозвіл можна дати пізніше через замочок в адресному рядку.',
        },
      ],
    },
    {
      titel: 'Внизу, згорнуто',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Запасний словник',
          uitleg:
            'Слова, які завжди мають перекладатися однаково: імена, фахові терміни, марки. Діє для всієї кімнати.',
        },
        {
          kop: 'Змінити налаштування',
          uitleg:
            'Мову, голос, тон і виправлення орфографії можна змінювати й ПОСЕРЕД розмови. Те, що ти змінюєш тут, одразу діє для обох.',
        },
      ],
    },
    {
      titel: 'Почати розмову',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Назва розмови',
          uitleg:
            'Може лишитися порожньою. Вона видна лише вгорі твого екрана, щоб ти знав, з ким говориш.',
        },
        {
          kop: 'Мовець 1 і мовець 2',
          uitleg:
            'Дві мови цієї розмови. Хто ввійде першим, займе перше місце. Мови можна поміняти місцями пізніше.',
        },
        {
          kop: 'Тон перекладу',
          uitleg:
            'Ліворуч ти вибираєш звертання на «ти» чи на «ви», праворуч настрій: нейтральний, дружній, діловий, офіційний або партнерський. Без вказівки модель майже завжди вибирає формальну форму, а у звичайній розмові це звучить відсторонено.',
        },
        {
          kop: 'Надсилати й власний голос',
          uitleg:
            'Співрозмовник може почути поряд із перекладом і твій власний запис. Зручно, щоб вивчати мову. Вимкни це в делікатній розмові: хто отримає запис, може його зберегти.',
        },
        {
          kop: 'Виправляти помилки у твоєму тексті',
          uitleg:
            'Увімкнено. Вимкни, щоб побачити, що модель зрозуміла насправді. Якщо тоді вийде дивна фраза, ти знатимеш, чи її розчули неправильно, чи розчули правильно й потім вигладили.',
        },
        {
          kop: 'З PIN-кодом',
          uitleg:
            'Передай код усно, а не в тому самому повідомленні, що й посилання. Це захищає від пересланого посилання.',
        },
        {
          kop: 'QR-код',
          uitleg:
            'Дай співрозмовнику відсканувати його або надішли посилання. Кімната сама завершується через чотири години.',
        },
      ],
    },
    {
      titel: 'Що відбувається з твоєю розмовою',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Текст не зберігається',
          uitleg:
            'Те, що ви говорите, не потрапляє до бази даних. Лише коли й скільки говорили, для обліку витрат.',
        },
        {
          kop: 'Записи зникають самі',
          uitleg: 'Звук лишається десять хвилин у пам’яті, а потім зникає.',
        },
        {
          kop: 'Кімната завершується',
          uitleg: 'Через чотири години після створення. Після цього посилання більше не працює.',
        },
        {
          kop: 'Є бюджет',
          uitleg:
            'На кімнату й на місяць. Якщо він вичерпається, застосунок припиняє перекладати і каже про це. Це не збій.',
        },
      ],
    },
  ],
};
